import { openBlock as l, createElementBlock as o, createElementVNode as e } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ e("path", {
  fill: "#D80027",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), c = /* @__PURE__ */ e("path", {
  fill: "#FFDA44",
  d: "M31.82 16.413h-9.03L20 7.826l-2.79 8.587H8.18l7.306 5.308-2.79 8.587L20 25l7.305 5.307-2.79-8.587 7.305-5.308Zm-14.29 4.643.944-2.904h3.053l.943 2.904L20 22.851l-2.47-1.795Zm3.432-4.643h-1.923l.961-2.96.962 2.96Zm2.988 3.568-.595-1.829h3.112l-2.517 1.83Zm-7.305-1.829-.594 1.83-2.518-1.83h3.112Zm-.642 7.603.962-2.96 1.556 1.13-2.518 1.83Zm5.477-1.83 1.555-1.13.962 2.96-2.517-1.83Z"
}, null, -1), s = [
  n,
  c
];
function h(r, m) {
  return l(), o("svg", t, [...s]);
}
const i = { render: h };
export {
  i as default,
  h as render
};
